import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserRoleChangeService {
  public showPop = new Subject();

  constructor() { }

  public showLogoutPop(): void {
    this.showPop.next();
  }
}
